import React from 'react';
interface EmblemProps {
  size?: number;
  className?: string;
  color?: string;
}
/**
 * Decorative emblem inspired by the Sinclairs quatrefoil mark.
 * Used as a section divider / brand seal throughout the site.
 */
export function Emblem({
  size = 24,
  className = '',
  color = 'currentColor'
}: EmblemProps) {
  return <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true" data-id="element-139">
      <g fill="none" stroke={color} strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" data-id="element-140">
        {/* Quatrefoil knot - 4 interlocking loops */}
        <path d="M24 8 C 20 12, 20 16, 24 20 C 28 16, 28 12, 24 8 Z" data-id="element-141" />
        <path d="M40 24 C 36 20, 32 20, 28 24 C 32 28, 36 28, 40 24 Z" data-id="element-142" />
        <path d="M24 40 C 28 36, 28 32, 24 28 C 20 32, 20 36, 24 40 Z" data-id="element-143" />
        <path d="M8 24 C 12 28, 16 28, 20 24 C 16 20, 12 20, 8 24 Z" data-id="element-144" />
        {/* Inner connecting points */}
        <circle cx="24" cy="24" r="1.5" fill={color} data-id="element-145" />
      </g>
    </svg>;
}
/**
 * Centered emblem divider with hairlines on either side.
 */
export function EmblemDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-5 ${className}`} data-id="element-146">
      <span className="h-px w-16 md:w-24 bg-gold/40" data-id="element-147" />
      <Emblem size={22} className="text-gold" data-id="element-148" />
      <span className="h-px w-16 md:w-24 bg-gold/40" data-id="element-149" />
    </div>;
}